import { is3DFile } from "./is3DFile";

export const has3DFile = <T extends { url: string; name: string }>(params: {
  files: T[] | null | undefined;
}) => {
  if (!params.files?.length) {
    return false;
  }

  return params.files.some((file) => {
    return is3DFile(file);
  });
};
